export const confirmationHeadingSx = {
  textAlign: 'center',
  marginBottom: '12px',
};

export const confirmationContentSx = { marginBottom: '24px' };

export const confirmationBtnContainerSx = {
  display: 'flex',
  justifyContent: 'space-around',
};

export const confirmationBtnSx = { width: '45%' };
